import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-615d8ee2"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "aild-login"
};
var _hoisted_2 = {
  class: "login-content"
};
var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "top"
  }, [/*#__PURE__*/_createElementVNode("img", {
    src: "https://img.pipabiancheng.com/competition/materials/2025/icc/0226/aild-top.png",
    alt: ""
  })], -1);
});
var _hoisted_4 = {
  class: "contest-area"
};
var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "slogon-box"
  }, [/*#__PURE__*/_createElementVNode("img", {
    src: "https://img.pipabiancheng.com/competition/materials/2025/icc/0226/aild-slogon.png",
    alt: ""
  })], -1);
});
var _hoisted_6 = {
  class: "login-box"
};
var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "contest-bot"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "txt-center"
  }, [/*#__PURE__*/_createTextVNode(" 报名id查询方式：登录大赛官网-我的团队-初赛（网站地址： "), /*#__PURE__*/_createElementVNode("a", {
    href: "http://aild.caa.org.cn",
    target: "_blank"
  }, " http://aild.caa.org.cn "), /*#__PURE__*/_createTextVNode(" ） ")]), /*#__PURE__*/_createElementVNode("div", {
    class: "txt-center"
  }, "版权所有 全国青少年劳动技能与智能大赛")], -1);
});
import ContestLogin from '../../common/components/ContestLogin/index.vue';
export default /*#__PURE__*/_defineComponent({
  setup: function (__props) {
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", _hoisted_6, [_createVNode(ContestLogin, {
        theme: "aild",
        carNoInfo: {
          placeholder: '请输入选手报名ID',
          ruleMessage: '请输入报名ID'
        },
        nameInfo: {
          placeholder: '请输入选手姓名',
          ruleMessage: '请输入选手姓名'
        },
        "contest-type": "aild",
        "contest-year": "2025"
      })])]), _hoisted_7])]);
    };
  }
});